<template>
  <div>
    <div class="truck-dimensions" v-if="truck">{{dimensions}}</div>
    <canvas
      id="truck-top"
      class="unselectable"
      @click="selectPallet($event)"
      @mousedown="mouseMove($event)"
      @contextmenu="showMenu"
    ></canvas>

    <v-menu v-model="menu" :position-x="x" :position-y="y" absolute offset-y>
      <v-list>
        <v-list-tile class="clickable" @click="flipPallet">
          <v-list-tile-title>{{ $t('truck_top.flip') }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import Truck from "@/models/Truck.js";
import Pallet from "@/models/Pallet.js";
import TruckTop from "@/models/TruckTop.js";
import Helper from "@/models/Helper.js";
export default {
  props: ["selectedTruck", "allPallets", "divider", "orders"],
  data() {
    return {
      truck: {},
      dimensions: "",
      x: 0,
      y: 0,
      menu: false
    };
  },

  async created() {
    this.initialize();
    document.addEventListener("moved", () => {
      this.truckTop.draw();
      this.getTruckDimensions();
    });
    document.addEventListener("dropped", () => {
      this.$emit("dropped", this.truck);
    });
    document.addEventListener("dragStart", () => {
      this.$emit("dragStart");
    });
  },

  methods: {
    async initialize() {
      await Helper.timeout(50);
      const newTruck = new Truck(this.selectedTruck);
      this.truck = newTruck.prepareForViewing(this.divider);
      const canvas = document.getElementById("truck-top");
      canvas.width = this.truck.getLength();
      canvas.height = this.truck.width;
      const ctx = canvas.getContext("2d");
      this.truckTop = new TruckTop(
        canvas,
        ctx,
        this.allPallets,
        this.truck,
        this.divider,
        this.orders
      );
      this.getTruckDimensions();
    },

    selectPallet(event) {
      this.selectedPallet = this.truck.overPallet(event);
      this.$emit("palletSelected", this.selectedPallet);
    },

    movePallet(coordinates) {
      if (this.selectedPallet) {
        this.selectedPallet.truck_x = coordinates.truck_x;
        this.selectedPallet.truck_y = coordinates.truck_y;
        this.truckTop.draw();
      }
    },

    mouseMove(event) {
      if (event.button != 0) return;
      this.truckTop.grab(event);
    },

    async rearrange() {
      this.rearranging = true;
      await this.truck.rearrangePallets();
      this.truckTop.updateCanvas();
      this.rearranging = false;
      this.$emit("dropped", this.truck);
    },

    async saveRearrange() {
      if(this.rearranging) return;
      const savingTruck = this.truck.prepareForSave();
      this.$store.commit('setLoading', true);
      await Pallet.updatePallets(savingTruck.pallets, true); // make sure length update is ignored
      this.$emit("updated");
    },

    getTruckDimensions() {
      const truck = this.truck;
      const length = Math.round(truck.getLength() * truck.divider);
      const width = Math.round(truck.width * this.divider);
      const height = Math.round(truck.height * truck.divider);
      this.dimensions = `${length} x ${width}, H = ${height}`;
    },

    showMenu(e) {
      if (this.truck.status >= 4) return;
      e.preventDefault();
      this.menu = false;
      this.selectPallet(e);
      if (!this.selectedPallet) return;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.menu = true;
      });
    },

    flipPallet() {
      this.selectedPallet.is_turned = !this.selectedPallet.is_turned;
      this.truckTop.updateCanvas();
      this.$emit("dropped", this.truck);
    }
  }
};
</script>

<style scoped>
.truck-dimensions {
  position: relative;
  font-weight: 800;
}
</style>